<template>
  <div class="menu-item-r">
    <div class="v-exhibits-management-wrap dash-form-container">
      <div class="v-em-header font-size-16 align-center">
        <div class="v-nav-wrap flex align-center">
          <div>
            <div class="searchExhibiList-input">
              <el-input v-model="searchKeywords" :placeholder="$t('productSearch')" size="small" clearable></el-input>
            </div>
            <el-button size="small" type="primary" class="search-btn" @click="getList">{{$t('common.search')}}</el-button>
          </div>
          <div>
            <el-button
              type="primary"
              size="small"
              icon="el-icon-circle-plus-outline"
              @click="$router.push('/add-exhibit')"
              >{{ $t('Add Exhibit') }}</el-button>
            <!-- <el-button size="small" class="search-btn" @click="showCheck(0)">{{ $t('Batch editing') }}</el-button>
            <el-button size="small" class="search-btn" @click="showCheck(1)">{{ $t('Batch deletion') }}</el-button> -->
            <!-- <el-button size="small" class="search-btn" @click="batchUpdate">{{ $t('Batch deletion') }}</el-button> -->
            <!-- <el-button size="small" type="primary" class="search-btn" @click="clickCheckBoxAll(products,'check')">全选</el-button>
            <el-button size="small" type="primary" class="search-btn" @click="clickCheckBoxAll(products,'del')">取消全选</el-button> -->
          </div>
          
        </div>
      </div>
      <div class="v-exhibits-management-list">
        <div v-if="check" class="checkDiv">
          <!-- <el-radio label="全部" v-model="checkedAll" @change="clickCheckBoxAll(products,'check',0)"></el-checkbox>
          <el-checkbox label="{{ $t('Select the current page') }}" v-model="checkedCurrent" @change="clickCheckBoxAll(products,'check',1)"></el-checkbox>{{checkedCurrent}} -->
          <el-radio-group v-model="radio">
            <el-radio label="all" @change="clickCheckBoxAll(products,'check',0)">{{ $t('common.all') }}</el-radio>
            <el-radio label="current" @change="clickCheckBoxAll(products,'check',1)">{{ $t('Select the current page') }}</el-radio>
          </el-radio-group>
          <el-link class="m-l-12 btn" :underline="false" @click="clickCheckBoxAll(products,'del')">{{$t('Cancel the full selection')}}</el-link>
          <!-- <el-link class="m-l-12 btn" :underline="false" @click="operate(checkTips)">{{checkTips == 0 ? $t('ok') : $t('del')}}</el-link> -->
          <el-link class="m-l-12 btn" :underline="false" @click="operate(0)">{{ $t('Batch editing') }}</el-link>
        <el-link class="m-l-12 btn" :underline="false" @click="operate(1)">{{ $t('Batch deletion') }}</el-link>
        </div>
        <el-row :gutter="30">
          <el-col :xs="6" :sm="6" :md="6" v-for="item in products" :key="item.productId" class="productBox">
            <input v-if="check" :disabled="checkedAllDis" class="productCheckbox" @click="clickCheckBox(item.productId)"  :checked="fruit.includes(item.productId)" type="checkbox" :value="item.productId" />
            <ExhibitCard
              @callback="callback"
              class="v-em-card"
              :slides="5"
              :vData="item">
              <div slot="exhibitsInfo" class="text-right theme-icon-color v-em-list">
                <div class="font-size-14 v-pointer-view" v-if="item.pageView">
                  <i class="el-icon-view"></i>&nbsp;&nbsp;<span>{{ item.pageView || 0 }} </span>
                </div>
              </div>
              <template slot="productName">
                {{language == 'en' ? (item.pdtEName || '--') : (item.productName || '--')}}
              </template>
              <span slot="collect"></span>
              <div slot="footer" class="v-em-footer flex-end">
                <div
                  class="pointer"
                  @click.stop="callback({ type: 'editor', data: { id: item.productId } })"
                >
                  <span
                    class="iconfont iconact_jiaobiaobianji theme-icon-primary-color"
                  ></span>
                  <span>{{ $t('editor') }}</span>
                </div>
                <div
                  class="pointer"
                  @click.stop="callback({ type: 'del', data: { id: item.productId } })"
                >
                  <span
                    class="iconfont iconqingkong- theme-icon-primary-color"
                  ></span>
                  <span>{{ $t('del') }}</span>
                </div>
                <div
                  class="pointer"
                  @click.stop="callback({ type: 'details', data: { id: item.productId } })"
                >
                  <span class="el-icon-tickets theme-icon-primary-color"></span>
                  <span>{{ $t('details') }}</span>
                </div>
              </div>
            </ExhibitCard>
          </el-col>
        </el-row>
        
      </div>
      <el-dialog :title="$t('Visible scope')" :visible.sync="dialogFormVisible" width="30%" :before-close="handleClose">
        <p class="dialogFormP">{{$t('Visible scope')}}</p>
        <el-select class="visibleScope" size="mini" v-model="region" :placeholder="$t('Please select the visible range')">
          <el-option :label="$t('common.allLook')" value="0"></el-option>
          <!-- <el-option :label="$t('common.onlyLook')" value="1"></el-option> -->
          <el-option :label="$t('common.onlyPreRegistered')" value="2"></el-option>
        </el-select>
        <div class="margin-t-12">
          <p class="dialogFormP">{{$t('Product tags')}}</p>
            <el-cascader
             id="elCascader"
              size="mini"
              v-model="questionList"
              :options="tagOptions"
              :props="tagProps"
              separator="："
              clearable
            >
            </el-cascader>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="dialogFormVisible = false,questionList = []">{{ $t('cancel' )}}</el-button>
          <el-button size="mini" type="primary" @click="validateForm(region)">{{$t('ok')}}</el-button>
        </div>
      </el-dialog>

      <el-pagination
        background
        :hide-on-single-page="true"
        :page-size="pagination.pageSize"
        :current-page="pagination.currentPage"
        layout="prev, pager, next"
        :total="pagination.total"
        @current-change="goPage">
      </el-pagination>
      <div v-if="check" class="checkDiv checkDivBot text-right p-r-24 margin-t-24">
        <el-radio-group v-model="radio">
          <el-radio label="all" @change="clickCheckBoxAll(products,'check',0)">{{ $t('common.all') }}</el-radio>
          <el-radio label="current" @change="clickCheckBoxAll(products,'check',1)">{{ $t('Select the current page') }}</el-radio>
        </el-radio-group>
        <el-link class="m-l-12 btn" :underline="false" @click="clickCheckBoxAll(products,'del')">{{$t('Cancel the full selection')}}</el-link>
        <!-- <el-link class="m-l-12 btn" :underline="false" @click="operate(checkTips)">{{checkTips == 0 ? $t('ok') : $t('del')}}</el-link> -->
        <el-link class="m-l-12 btn" :underline="false" @click="operate(0)">{{ $t('Batch editing') }}</el-link>
        <el-link class="m-l-12 btn" :underline="false" @click="operate(1)">{{ $t('Batch deletion') }}</el-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getProductTags, getProducts, deleteProduct, batchUpdateScope, batchUpdateScopeAll, batchDelete, batchDeleteAll } from '@/api'
import ExhibitCard from '@/components/card/ExhibitCard'
import xz from '../../../src/assets/images/xz.png'
export default {
  name: 'MyExhibitList',
  components: {
    ExhibitCard
  },
  data() {
    return {
      checkedAll:false,
      checkedCurrent:false,
      radio:'',
      questionList: [],
      tagProps: {
        multiple: true,
        label: 'aliasName',
        value: 'id',
        children: 'children'
      },
      tagOptions: [],
      checkedAllDis:false,
      checkTips:0,
      xz: xz,
      fruit: [],
      check: true,
      dialogFormVisible: false,
      region: '',
      form: {
        region: '',
      },
      formLabelWidth: '120px',
      pagination: {
        pageSize: 12,
        total: 0,
        currentPage: 1
      },
      products: [],
      productsArr: [],
      // 关键字
      searchKeywords: ''
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  watch:{
    fruit: {
      handler(newVal) {
        if(this.radio == 'all') {
          this.radio = 'all'
        } else if (this.radio == 'current') {
          this.productsArr = [];
          for(let i in this.products) {
            this.productsArr.push(this.products[i]['productId'])
          }
          if (this.compare(this.productsArr,newVal)) {
            this.radio = 'current'
          } else {
            this.radio = ''
          }
        }
      },
      deep:true
    },

  },
  mounted() {
    this.getList()
    this.getTags()
  },
  methods: {
    handleClose() {
      this.questionList = []
      this.dialogFormVisible = false
    },
    getTags() {
      getProductTags({
        showType: 'PRODUCT_PUBLISH'
      }).then(res => {
        const formatQuestionData = function(data) {
          for(let i=0; i<data.length; i++) {
            if((data[i].answerList && data[i].answerList.length > 0) || (data[i].subAnswerList && data[i].subAnswerList.length > 0)){
              data[i].children = data[i].subAnswerList || data[i].answerList
              formatQuestionData(data[i].answerList || data[i].subAnswerList )
            }
          }
          return data
        }
        this.tagOptions = formatQuestionData(res.data.data.questionList || [])
        this.tagProps.multiple = res.data.data.selectedType === 'multiple'
      })
    },
    validateForm() {
      if(this.region == '' && this.questionList.length == 0) {
        this.$notify({
          message: this.$t('Please select the visible range2'),
          type: 'warning'
        });
      } else if (this.questionList.length != 0) {
        if (this.tagProps.multiple && this.questionList instanceof Array) {
          let a = []
          this.questionList.forEach(item => {
            if(item[0] == '2011baoliqiuji' || item[0] == '20111baoliqiuji') {
              a.push(item)
            }
          })
          if (a.length > 3) {
            this.$notify.error(this.$t('productError'))
            return false
          } else {
            this.checkScope()
          }
        } else {
          this.checkScope()
        }
      } else {
        this.checkScope()
      }
    },
    // TODO: may need get with lang
    getTagName(item) {
      const level1 = this.tagOptions.find(i => {
        return i.id === item[0]
      })

      if (!level1) {
        return ''
      }

      const level2 = level1.children.find(i => {
        return i.id === item[1]
      })

      if (!level2) {
        return ''
      }

      return `${level1.name}:${level2.name}`
    },
        
    operate(type) {
      if(this.radio == 'all') {
        this.region = '';
        if(type == 0) {
          this.dialogFormVisible = true
        } else if(type == 1) {
          this.$alert(
            this.$t('Are you sure detele this item1?'),
            this.$t('Confirm'),
            {
              showCancelButton: true,
              callback: action => {
                if (action === 'confirm') {
                  batchDeleteAll({ searchKeywords: this.searchKeywords }).then(res => {
                    if (res.data.code === 1000) {
                      this.fruit = [];
                      this.radio = '';
                      this.pagination.currentPage = 1;
                      this.getList()
                    }
                  })
                }
              }
            }
          )
        }
      } else if (this.radio == 'current') {
        if(type == 0){
          if (this.fruit.length == 0) {
            if(this.products.length == 0) {
              this.$notify({
                message: this.$t('No data on the current page'),
                type: 'warning'
              });
            } else {
              this.$notify({
                message: this.$t('Please select the exhibits to be modified'),
                type: 'warning'
              });
            }
            
          } else {
            this.region = '';
            this.dialogFormVisible = true
          }
        } else if (type == 1) {
          if (this.fruit.length == 0) {
            if(this.products.length == 0) {
              this.$notify({
                message: this.$t('No data on the current page'),
                type: 'warning'
              });
            } else {
              this.$notify({
                message: this.$t('Please select the exhibits to be modified'),
                type: 'warning'
              });
            }
            
          } else {
            this.$alert(
              this.$t('Are you sure detele this item1?'),
              this.$t('Confirm'),
              {
                showCancelButton: true,
                callback: action => {
                  if (action === 'confirm') {
                    batchDelete({ idList:this.fruit }).then(res => {
                      if (res.data.code === 1000) {
                        this.fruit = [];
                        this.radio = '';
                        this.pagination.currentPage = 1;
                        this.getList()
                      }
                    })
                  }
                }
              }
            )
          }
          
        }
      } else {
        if(type == 0){
          if (this.fruit.length == 0) {
            if(this.products.length == 0) {
              this.$notify({
                message: this.$t('No data on the current page'),
                type: 'warning'
              });
            } else {
              this.$notify({
                message: this.$t('Please select the exhibits to be modified'),
                type: 'warning'
              });
            }
            
          } else {
            this.region = '';
            this.dialogFormVisible = true
          }
        } else if (type == 1) {
          if (this.fruit.length == 0) {
            if(this.products.length == 0) {
              this.$notify({
                message: this.$t('No data on the current page'),
                type: 'warning'
              });
            } else {
              this.$notify({
                message: this.$t('Please select the exhibits to be modified'),
                type: 'warning'
              });
            }
            
          } else {
            this.$alert(
              this.$t('Are you sure detele this item?'),
              this.$t('Confirm'),
              {
                showCancelButton: true,
                callback: action => {
                  if (action === 'confirm') {
                    batchDelete({idList:this.fruit}).then(res=>{
                      if(res.data.code == 1000) {
                        this.$notify({
                          message: res.data.message,
                          type: 'success'
                        });
                        this.dialogFormVisible = false;
                        this.fruit = [];
                        this.radio = '';
                        this.pagination.currentPage = 1;
                        this.getList()
                      }
                    })
                  }
                }
              }
            )
            
          }
          
        }
      }
    },
    // 显示 全部/当前页 选择按钮
    showCheck(type) {
      this.check = true;
      this.checkTips = type
    },
    // 操作选择数据
    checkScope() {
      let params = {
        scope: null,
        questionList: null
      } 
      let questionList = []
      if (this.region) {
        params.scope= this.region
      }
      if(this.questionList.length > 0){
        if(this.tagProps.multiple) {
          this.questionList.forEach(item => {
            questionList.push({
              questionId: item[0],
              answerIds: [item[item.length - 1]],
              tagNames: [this.getTagName(item)]
            })
          })
        } else {
          let item = this.questionList
          questionList.push({
            questionId: item[0],
            answerIds: [item[item.length - 1]],
            tagNames: [this.getTagName(item)]
          })
        }
        params.questionList = questionList
      }
      if(this.radio == 'all'){
        //调用全部接口
        params.searchKeywords=this.searchKeywords,
        batchUpdateScopeAll(params).then(res=>{
          if(res.data.code == 1000) {
            this.$notify({
              message: res.data.message,
              type: 'success'
            });
            this.dialogFormVisible = false;
            this.questionList = []
            this.getList()
          }
        })

      }else if(this.radio == 'current') {
        // 调用当前页接口
        params.idList= this.fruit
        batchUpdateScope(params).then(res=>{
          if(res.data.code == 1000) {
            this.$notify({
              message: res.data.message,
              type: 'success'
            });
            this.dialogFormVisible = false;
            this.questionList = []
            this.getList()
          }
        })
      } else {
        if(this.fruit.length>0 && this.radio != 'all') {
          // 调用 当前页接口
          params.idList= this.fruit
          batchUpdateScope(params).then(res=>{
            if(res.data.code == 1000) {
              this.$notify({
                message: res.data.message,
                type: 'success'
              });
              this.dialogFormVisible = false;
              this.questionList = []
              this.getList()
            }
          })
        }
      }
        
    },
    
    batchUpdate() {
      if (this.fruit.length == 0) {
        this.$notify({
          message: this.$t('Please select the exhibits to be modified'),
          type: 'warning'
        });
      } else {
        this.region = '';
        this.dialogFormVisible = true
      }
    },
    // 过滤相同元素
    unique(arr) {
      return Array.from(new Set(arr));
    },
    // 点击单个复选框
    clickCheckBox(val){
      if(this.fruit.includes(val)){
        this.fruit.splice(this.fruit.indexOf(val),1);
      }else{
        this.fruit.push(val);
      }
      this.fruit = this.unique(this.fruit)
    },
    // 选择全部/当前页
    clickCheckBoxAll(data,type,num){
      if(type == 'del') {
        this.fruit = [];
        this.radio = '';
        this.checkedAllDis = false
      } else {
        this.fruit = [];
        if(num == 0) {
          this.checkedAllDis = true
          this.radio = 'all'
          
          for(let i in data) {
            this.fruit.push(data[i]['productId'])
          }
        } else if (num == 1) {
          this.checkedAllDis = false
          if(this.radio == 'current'){
            for(let i in data) {
              this.fruit.push(data[i]['productId'])
            }
          }else {
            for(let i in data) {
              this.fruit.pop(data[i]['productId'])
            }
          }
        }

        this.fruit = this.unique(this.fruit)
      }
      
      
    },
    // 对比数组，
    compare(arr1, arr2) {
      //临时数组，用于对比删除项
      let tempArr = [...arr2]
      if (arr1 instanceof Array && arr2 instanceof Array) {
          return arr1.length == arr2.length && arr1.every((item_1) => {
              //临时数组需要删除的索引
              let delIndex = 0
              //是否对比成功
              let result = false
              if (isNaN(item_1)) {
                  result = tempArr.some((item_2, index) => {
                      if (isNaN(item_2)) {
                          delIndex = index
                          return true
                      }
                      return false
                  })
              } else {
                  delIndex = tempArr.indexOf(item_1)
                  result = delIndex != -1
              }
              tempArr.splice(delIndex, 1)
              return result
          })
      } else {
          return false
      }
    },

    getList() {
      let pageInfo = {
        pageRows: this.pagination.pageSize,
        pageNum: this.pagination.currentPage,
        searchKeywords:  this.searchKeywords,
        showType: "PRODUCT_LIST",
      }
      const loading = this.$loading()
      getProducts(pageInfo)
        .then(res => {
          this.pagination.total = res.data.data.total
          this.pagination.currentPage = res.data.data.pageNum
          this.products = res.data.data.list
          this.fruit = [];
          if (this.radio == 'current') {
            this.productsArr = [];
            for(let i in this.products) {
              this.productsArr.push(this.products[i]['productId'])
            }
            for(let i in this.productsArr) {
              this.fruit.push(this.productsArr[i])
            }
            this.fruit = this.unique(this.fruit)
          } else if (this.radio == 'all'){
            for(let i in this.products) {
              this.productsArr.push(this.products[i]['productId'])
            }
            for(let i in this.productsArr) {
              this.fruit.push(this.productsArr[i])
            }
            this.fruit = this.unique(this.fruit)
          }
        })
        .finally(() => {
          loading.close()
        })
    },

    goPage(val) {
      this.fruit = [];
      this.pagination.currentPage = val
      this.getList()
    },

    callback(res) {
      if (res.type == 'editor') {
        this.$router.push(`/exhibit/${res.data.id}`)
      } else if (res.type == 'del') {
        this.$alert(
          this.$t('Are you sure detele this item?'),
          this.$t('Confirm'),
          {
            showCancelButton: true,
            callback: action => {
              if (action === 'confirm') {
                deleteProduct({ id: res.data.id }).then(res => {
                  if (res.data.code === 1000) {
                    this.getList()
                  }
                })
              }
            }
          }
        )
      } else if (res.type == 'details') {
        let id = res.data.id || res.data.productId
        this.$router.push(`/exhibit-detail/${id}`)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.dialogFormP{
  height 32px
  line-height 32px
}
.v-pointer-view{
  display: inline-block;
}
.productBox{
  position relative
}
.productCheckbox {
  position absolute
  top 10px
  left 28px
  z-index 111
  background:$color-white
}
.checkDiv{
  margin-top: -20px;
  width 100%
  height 60px
  line-height 60px
  background-color: $color-gray-fb
}
.checkDivBot{
  background-color: $color-bg-e9
}
.v-exhibits-management-wrap

  >>> .v-exhibits-detail
    max-width 100%!important

  .v-em-header
    // padding:40px 0;

    .el-select
      margin-left 12px

    .v-audit-status-1
      color $color-main
      margin-left 4px

    .v-audit-status-2
      color $color-blue-50
      margin-left 4px

    .v-audit-status-3
      color $color-red-f5
      margin-left 4px

  .v-exhibits-management-list
    flex-wrap wrap
    input[type="checkbox"] {
      -webkit-appearance: none; /*清除复选框默认样式*/
      // border: 1px solid $color-main;
      vertical-align: middle;
      width: 16px;
      height: 16px;
      float: left;
      margin-top: 0;
      margin-right: 0 !important;
      border-radius: 2px;
    }
    input[type="checkbox"]:checked {
      background: $color-main url('../../../src/assets/images/xz.png'); /*复选框的背景图*/
      background-size: contain;
    }

    .v-em-card
      margin 0 15px 25px 0
      &:nth-child(3n+0)
        margin-right: 0
      // @media screen and (max-width: $container-width)
      //   &:nth-child(3n+0)
      //     margin-right: 15px
      //   &:nth-child(2n+0)
      //    margin-right: 0

  .v-em-list
    padding 8px

  .v-em-footer
    >div
      margin-left 15px
  .el-pagination
    text-align right
.visibleScope, #elCascader{
  width: 100%
}
.btn{
  color $color-main
}
</style>
